import React from 'react';
import { useParams } from 'react-router-dom';
import { Box, IconButton, Typography } from '@mui/material';
import { LocalAtmTwoTone, MessageTwoTone, TimelapseTwoTone, ExpandMore, ExpandLess } from '@mui/icons-material';
import { useJourneyStepStats } from '../../../../../api/Journeys/journey_queries';
import { SidebarGroup } from 'components/index';
import StatsMessage from '../../Stats/StatsMessage';

const MessageEmailReport = ({ stepId }) => {
    const { id: journeyIdStr } = useParams();
    const journeyId = parseInt(journeyIdStr);

    // TODO? move the query into the stats component itself?
    const { status, data, error, isFetching } = useJourneyStepStats(journeyId, stepId);

    return (
        <Box className='flow-sidebar__body' p={0}>
            <Box className='flow-sidebar__body-content'>
                {status === 'loading' ? (
                    'Loading...'
                ) : status === 'error' ? (
                    <span>Error: {error.message}</span>
                ) : (
                    <>{isFetching ? 'Background Updating...' : <StatsMessage stats={data} />}</>
                )}
            </Box>
        </Box>
    );
};

export default MessageEmailReport;
